import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ReactNode, useCallback, useState } from "react";

export interface MoreListProps<T> {
  data: T[];
  Component: ({ data }: { data: T[] }) => ReactNode;
  size: number;
  children: ReactNode;
}

export const MoreList = <T,>({ data, Component, size, children }: MoreListProps<T>) => {
  const [limit, setLimit] = useState(size);
  const clickMore = useCallback(() => {
    setLimit(limit === data.length ? size : data.length);
  }, [limit, setLimit, data, size]);
  if (!data.length) return null;
  return (
    <>
      <Component data={data.slice(0, limit)} />
      {data.length > size && (
        <div className="text-center" style={{ marginTop: 0 }}>
          <button
            className="text-sm bg-bright-yellow hover:bg-yellow p-0.5 rounded-b rounded-mb"
            onClick={clickMore}
          >
            {data.length > limit ? children : "Toon minder"}{" "}
            <FontAwesomeIcon
              icon={data.length > limit ? faChevronDown : faChevronUp}
              className="inline w-6 h-6"
              fill="currentColor"
            />
          </button>
        </div>
      )}
    </>
  );
};
